import { Component, OnInit } from '@angular/core';
import { BoletoService } from 'src/app/services/convenio/boleto.service';
import { longNumber } from '../../../../app/utils/index';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { postedBoleto, postBoleto } from '../../../../app/state/actions/scanBoleto.actions'
import { Boleto } from 'src/app/models';
import * as moment from 'moment';
import { selectUser } from 'src/app/state/selectors/user.selectors';


@Component({
  selector: 'app-scan-boleto',
  templateUrl: './scan-boleto.component.html',
  styleUrls: ['./scan-boleto.component.scss']
})
export class ScanBoletoComponent implements OnInit {
  scanCode
  codigoQR = ''
  actualUser: any;
  baseBoletos
  formulario: Boleto;
  color = '';
  constructor(
    private boletoService: BoletoService,
    private ngxServiceLoader: NgxUiLoaderService,
    private store: Store<AppState>,
    private toastr: ToastrService,
    private router: Router,

  ) {

  }

  ngOnInit(): void {
    //obtener base del servicio
    this.baseBoletos = this.boletoService.base
    console.log(this.baseBoletos);

    // this.boletoService.getBoletosActivos().subscribe(data => {
    //   this.baseBoletos = data;
    // });
    if (this.baseBoletos.length == undefined) {
      this.toastr.info('', 'Ingrese nuevamente para obtener boletos', { positionClass: 'toast-bottom-right' })
      this.router.navigate(['/mopa/home']);

    }

    this.store.select(selectUser).subscribe(user => {
      this.actualUser = user;
    })
  }

  onChangeTN(e: number) {
    console.log(e);
    this.scanCode = e;
  }

  validateScanCode(e) {
    console.log(e);
    //validar que sean 8 digitos
    if (!longNumber(e.length)) {
      this.ngxServiceLoader.stop();
      return this.toastr.error('El codigo debe tener 8 digitos', 'Revisa el codigo', { positionClass: 'toast-bottom-right' });
    }
    //validar que exista en la base local
    this.validateBoleto(e)

  }

  saveScanCode() {
    //validar el monto total sea mayor al costo del boleto
    if (Number(this.formulario.saldo) <= Number(this.formulario.monto)) {
    return  this.toastr.error('Saldo insuficiente', `Saldo: ${this.formulario.saldo},  Boleto: ${this.formulario.monto}` , { positionClass: 'toast-bottom-right' });
    }
    //guardar en redux e indexdb
    let boleto: Boleto =
    {
      _id: this.formulario._id,
      id: this.formulario.id,
      no_boleto: this.formulario.no_boleto,
      codigo_qr: this.formulario.codigo_qr,
      estatus: 2,
      fecha_cruce: moment().format('YYYY-MM-DD HH:mm:ss'),
      id_corte_usuario: this.actualUser.id_corte_usuario,
    }

    console.log(boleto);

    this.store.dispatch(postBoleto({ boleto }))
    //setear arreglo de boletos
    this.baseBoletos[this.formulario.index].estatus = 2
    this.boletoService.base = this.baseBoletos;
    console.log(this.baseBoletos);
    this.toastr.success('', 'Se ha guardado el boleto con éxito', { positionClass: 'toast-bottom-right' })
    this.formulario = null;

    //Redireccionar
    //this.router.navigate(['/mopa/home']);

  }

  cancelAction() {
    this.router.navigate(['/mopa/home']);
  }

  validateBoleto(numero) {
    //obtener info boleto
    var result;
    result = this.baseBoletos.filter(b => b.no_boleto == numero);
    //validar si existe el boleto en la bd local y no este activo
    let index = this.baseBoletos.findIndex(m => m.no_boleto == numero && m.estatus == 1);
    if (index === -1) {//no encontrado
      this.toastr.error('No se encontro el boleto', 'Revisa el codigo', { positionClass: 'toast-bottom-right' });
      this.formulario = null;
    } else
      //setear formulario
      this.setFormulario(result, index);
  }

  /*
  Revisa que el codigo QR exista y este diponible
  para cruce
   */
  validateQR(cadena) {
    var result;
    result = this.baseBoletos.filter(b => b.codigo_qr == cadena);
    let index = this.baseBoletos.findIndex(z => z.codigo_qr == cadena && z.estatus == 1);
    index === -1 ?
      this.toastr.error('Boleto no encontrado', 'Codigo invalido', { positionClass: 'toast-bottom-right' }) :
      this.setFormulario(result, index);
  }

  setFormulario(result, index) {
    this.formulario = result[0];
    this.formulario.index = index;
    console.log(this.formulario);
    //this.toastr.info('Boleto encontrado', 'Verifique el boleto', { positionClass: 'toast-bottom-right' })
    console.log(index);

    this.color = this.getColorTicket(this.formulario?.id_scct_tarifa)
  }

  recibiRespuesta(respuesta) {
    //eliminar datos del formulario
    this.formulario = null
    console.log(respuesta);

    this.codigoQR = respuesta;
    //validar logitud
    //quitar **
    var lec = respuesta.split('**')
    //validar codigo qr
    this.validateQR(lec[1])

  }
  getColorTicket(id_clasificacion: any) {
    switch (id_clasificacion) {
      case 1://moto
        return "blue";
        break;
      case 2://auto
        return "hotpink";
        break;
      case 3:// auto con remolque
        return "darkviolet";
        break;
      case 4://Bus 2
        return "#E74C3C";
        break;
      case 5://B3
        return "saddlebrown";
        break;
      case 6://B4
        return "darkgreen";
        break;
      case 7://C2
        return "#E74C3C ";
        break;
      case 8://C3
        return "saddlebrown";
        break;
      case 9://C4
        return "darkgreen";
        break;
      case 10://C5
        return "darkorange";
        break;
      case 11://C6
        return "#000";
        break;
      case 12://C7
        return "darkviolet";
        break;
      case 13://C8
        return "green";
        break;
      case 14://C9
        return "darkcyan";
        break;
      case 15://EEC
        return "orange";
        break;
      default: return "#fff";
    }
  }

}
